<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商品ID" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.id" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品编号" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsCode" placeholder="请输入商品编号"></el-input>
					</el-form-item>
					<el-form-item label="商品状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择商品状态">
							<el-option key="0" label="下架" :value="false">下架</el-option>
							<el-option key="1" label="上架" :value="true">上架</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.authStatus" placeholder="请选择审核状态">
							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="已审核" :value="1">已审核</el-option>
							<el-option key="2" label="已驳回" :value="2">已驳回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="供应商名称" class='tiny' cleartable>
						<el-select v-model="searchInfo.storeId" placeholder="请选择供应商名称">
							<el-option v-for="item in storeList" :key="item.id" :value="item.id"
								:label="item.storeName">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="商品类别" class='tiny' cleartable>
						<el-select v-model="searchInfo.isDh" placeholder="请选择">
							<el-option key="0" label="首页产品" :value="0"></el-option>
							<el-option key="1" label="兑换产品" :value="1"></el-option>

						</el-select>
					</el-form-item> -->

					<template>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button @click="empty">清空</el-button>
						<el-button type="primary" @click="dialogVisibleFun()">新增商品</el-button>
						<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
					</template>
					<!-- </el-form-item> -->
				</el-form>
			</header>
		</div>
		<el-table :data="goodsList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand" width="30px">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="店铺名称">
							<span v-if="props.row.storeId!=0">{{ props.row.storeName }}</span>
							<span v-else>无</span>
						</el-form-item>
						<el-form-item label="商品ID">
							<span>{{ props.row.id }}</span>
						</el-form-item>
						<el-form-item label="商品名称">
							<span>{{ props.row.goodsName }}</span>
						</el-form-item>
						<el-form-item label="商品编号">
							<span>{{ props.row.goodsCode?props.row.goodsCode:'无' }}</span>
						</el-form-item>
						<el-form-item label="市场价">
							<span>￥{{ props.row.marketPrice }}</span>
						</el-form-item>
						<!-- <el-form-item label="零售价">
							<span>￥{{ props.row.price }}</span>
						</el-form-item> -->
						<el-form-item label="供应价">
							<span>￥{{ props.row.costPrice }}</span>
						</el-form-item>

						<!-- <el-form-item label="是否兑换">
							<span v-if="props.row.isDh">是</span>
							<span v-else>否</span>
						</el-form-item> -->
						<!-- 				<el-form-item label="是否爆品">
							<span v-if="props.row.isCrontab">是</span>
							<span v-else>否</span>
						</el-form-item> -->
						<!-- <el-form-item label="是否超值精选">
							<span v-if="props.row.isDiscounts">是</span>
							<span v-else>否</span>
						</el-form-item> -->
						<!-- 			<el-form-item label="是否体验区">
							<span v-if="props.row.isChoiceness">是</span>
							<span v-else>否</span>
						</el-form-item> -->
						<el-form-item label="排序级别">
							<span>{{ props.row.orderIndex }}</span>
						</el-form-item>
						<el-form-item label="商品简单描述">
							<span>{{ props.row.remark?props.row.remark:'无' }}</span>
						</el-form-item>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(props.row.detail,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="商品图片">
							<el-button size="small" type="text" @click="findDetail(props.row.images,2)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="商品ID" width="100px" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="images" label="商品图片" align="center" >
				<template slot-scope="scope">
					<img :src="scope.row.images.split(',')[0]" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称" min-width="200px" align="center" >
			</el-table-column>
			<!-- 	<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="storeName" label="供应商名称" min-width="150px" align="center" >
			</el-table-column>
			<!-- 	<el-table-column prop="isDh" label="商品类别" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isDh==1">兑换产品</p>
					<p v-if="scope.row.isDh==0">首页产品</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="status" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.authStatus==0"><el-badge></el-badge><span style="font-size: 16px;">●</span>未审核</p>
					<p v-if="scope.row.authStatus==1"><span style="color: green;font-size: 16px;">●</span>已通过</p>
					<p v-if="scope.row.authStatus==2"><span style="color: red;font-size: 16px;">●</span>已驳回</p>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="商品状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0">下架</p>
					<p v-if="scope.row.status==1">上架</p>
				</template>
			</el-table-column>

			<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="允许负库存" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isNegativeStock==true">是</p>
					<p v-if="scope.row.isNegativeStock==false">否</p>
				</template>
			</el-table-column>
			<el-table-column prop="costPrice" label="成本价" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="agreementPrice" label="协议价" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="price" label="零售价" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->


			<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center"  fixed="right">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑</el-button>　　
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==0 && scope.row.authStatus==1">上架</el-dropdown-item>
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==1 && scope.row.authStatus==1">下架</el-dropdown-item>
							<el-dropdown-item @click.native="saleset(scope.row.id)" v-if="scope.row.isForbidSale==false" style="color:red">禁售
							</el-dropdown-item>
							<el-dropdown-item @click.native="saleset(scope.row.id)" v-if="scope.row.isForbidSale==true">恢复销售
							</el-dropdown-item>
							<el-dropdown-item @click.native="bohui(scope.row.id)" v-if="scope.row.authStatus==0&&storeId==0">驳回
							</el-dropdown-item>
							<el-dropdown-item @click.native="sh(scope.row.id)" v-if="scope.row.authStatus==0&&storeId==0">审核
							</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.authStatus==1" style="color: green;">已通过
							</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.authStatus==2" style="color: green;">已驳回
							</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.authStatus==2" style="color: green;">已驳回
							</el-dropdown-item>
							<el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>　　
				</template>　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
			<div v-if="detailType == 2"
				style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
				<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 编辑商家 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisible" width="80%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div>
					

						<div style="display: flex;align-items: center;justify-content: space-between;">
					
							<el-form-item label="供应商">
								<el-select v-model="storeGoodsInfo.storeId" class="big" placeholder="请选择"
									@change="getStoreAndUser1"
									style="margin-left: 12px;"
									>
									<el-option v-for="item in storeList" :key="item.id" :value="item.id"
										:label="item.storeName">
									</el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商品名称" style="width: 50%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.goodsName" placeholder="请输入商品名称" />
						</el-form-item>
						<el-form-item label="商品编号" style="width: 40%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.goodsCode" placeholder="请输入商品编号" />
						</el-form-item>
					</div>
					<div style="width: 500px;">
						<el-form-item label="商品分类" style="width: 100%;">

							<el-select clearable v-model="classGoods1Id" placeholder="请选择分类" style="margin-right:10px;"
								@change="classGoods1" filterable>
								<el-option clearable v-for="item in classGoods1List" :key="item.id"
									:label="item.className" :value="item.id">
								</el-option>
							</el-select>

							<el-select clearable v-model="classGoods2Id" placeholder="请选择二级分类"
								style="width:50%;margin:0px 10px;" @change="classGoods2">
								<el-option v-for="item in classGoods2List" :key="item.id" :label="item.className"
									:value="item.id">
								</el-option>
							</el-select>

							<el-select clearable v-model="classGoods3Id" placeholder="请选择三级分类"
								style="width:50%;margin:0px 10px;" @change="classGoods3">
								<el-option v-for="item in classGoods3List" :key="item.id" :label="item.className"
									:value="item.id">
								</el-option>
							</el-select>

						</el-form-item>
						<el-form-item label="品牌">
							 <el-select
							  v-model="classbrandId"
							   filterable 
							   placeholder="请选择品牌"  
								@change="classbrand"
									:filter-method="inputsj"
								style="margin-left: 27px;"
							   >
							  
								   <el-option
							      v-for="item in pp"
							      :key="item.id"
							      :label="item.name"
							      :value="item.id">
							    </el-option>
							
							    
							  </el-select>
						</el-form-item>
						<!-- 	<el-form-item label="pv" style="width: 40%;">
							<el-input type="number" clearable v-model="storeGoodsInfo.pv"
								oninput="if(value<0){value=0}else if(value>1){value=1}" placeholder="请输入" />
						</el-form-item> -->
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="供应成本价" class="redItem" style="" v-if="storeGoodsInfo.authStatus!=1">
							<el-input type="number" size="small" width="50" v-model="storeGoodsInfo.costPrice"
								placeholder="请输入数字" />
						</el-form-item>
						<el-form-item label="供应成本价" class="redItem" style="" v-else>
						<span>{{storeGoodsInfo.costPrice}}</span>	
						
						</el-form-item>

						<el-form-item label="建议零售价" class="redItem">
							<el-input type="number" size="small" width="50" v-model="storeGoodsInfo.price"
								placeholder="请输入数字" />
						</el-form-item>
						<el-form-item label="市场参考价" class="redItem">
							<el-input type="number" size="small" width="50" v-model="storeGoodsInfo.marketPrice"
								placeholder="请输入数字" />
						</el-form-item>
						<!-- <el-form-item label="供应价" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.costPrice" placeholder="请输入数字" />
						</el-form-item> -->
					</div>
					<div>
						<el-form-item label="是否开启分销商协议价" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isOpenIdentityPrice" :active-value="true"
								:inactive-value="false">
							</el-switch>
						</el-form-item>
						<el-form-item label="协议价" class="redItem" v-if="!storeGoodsInfo.isOpenIdentityPrice">
							<el-input style="margin-left: 13px;" type="number" size="small" width="50" v-model="storeGoodsInfo.agreementPrice"
								placeholder="请输入协议价" />
						</el-form-item>
						<div class="redItem" v-else style="width: 441px;">

							<el-table :data="tableData" border size="small" style="width: 50%;margin-left: 80px;">
								<el-table-column label="分销商身份" width="180">
									<template slot-scope="scope">

										<span style="margin-left: 10px">{{ scope.row.name }}</span>
									</template>
								</el-table-column>
								<el-table-column label="协议价" width="180">
									<template slot-scope="scope">

										<el-input type="number" v-model="scope.row.agreementPrice" placeholder="请输入协议价">

										</el-input>
									</template>
								</el-table-column>

							</el-table>

						</div>


					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="排序级别" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.orderIndex" placeholder="请输入数字(降序)" />
						</el-form-item>
						<el-form-item label="销量" class="redItem">
							<el-input type="number" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.salesSum" placeholder="请输入数字" />
						</el-form-item>
						
					</div>
					<div style="display: flex;align-items: center;flex-direction: row;">
					<el-form-item label="库存" class="redItem">
						<el-input type="number" style="margin-left: 27px;" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
							v-model="storeGoodsInfo.stock" placeholder="请输入数字" />
					</el-form-item>
						<el-form-item label="单位" style="margin-left: 5px;">
							 <el-select
							 style="margin-left:10px"
							  v-model="classunitId"
							   filterable 
							   placeholder="请选择单位"  
								@change="classunit"
							   >
							  
								   <el-option
							      v-for="item in unitlist"
							      :key="item.id"
							      :label="item.name"
							      :value="item.id">
							    </el-option>
							
							    
							  </el-select>
						</el-form-item>
						<el-form-item label="是否上架" class="redItem" style="flex: 25%;margin-left: 5px;">
							<el-switch v-model="storeGoodsInfo.status" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
						<el-form-item label="是否允许负库存" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isNegativeStock" :active-value="1" :inactive-value="0">
							</el-switch>
						</el-form-item>

					</div>
					<div style="display: flex;align-items: center;">
						<!-- 	<el-form-item label="是否爆品" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isCrontab" :active-value="true" :inactive-value="false"
								@change="selectisCrontab">
							</el-switch>
						</el-form-item> -->
						<!-- <el-form-item label="是否超值精选" class="redItem" style="flex: 25%;" >
							<el-switch v-model="storeGoodsInfo.isDiscounts" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item> -->
						<!-- <el-form-item label="是否体验区" class="redItem" style="flex: 25%;"
							v-if="storeGoodsInfo.isCrontab==true">
							<el-switch v-model="storeGoodsInfo.isChoiceness" :active-value="true"
								:inactive-value="false" @change="selectisChoiceness">
							</el-switch>
						</el-form-item> -->
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商品图片(1:1)" style="width: 100%;display: flex;align-items: initial;">
							<br />
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"
								:on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div>
						<div style="text-align: start;margin: 10px;">商品详情</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.detail" ref="myQuillEditor" class="editer"
									style="height: 600px;width: 1000px;" :options="editorOption"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>

				</el-form>
			</div>
			<div style="text-align: center;margin-top: 100px;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增商品'" type="primary" @click="add">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑商品'" type="primary" @click="sure">编 辑</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		<el-dialog title="商品驳回" :visible.sync="dialogbhVisible" :close-on-click-modal="false">
			<el-form :model="form">
				<el-form-item label="驳回原因:">
					<el-input v-model="form.detail" autocomplete="off" placeholder="请输入驳回原因"></el-input>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogbhVisible = false">取 消</el-button>
				<el-button type="primary" @click="suredetail">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};

	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				storeId:'',
				tableData: [],

				form: {},
				ids: '',
				buy: {
					goodId: null,
					goodsName: null,
					price: null,
					num: null,
					storeId: null,
					status: false,
					goodsImages: ""
				},
				dialogbhVisible: false,
				setUpBuyVisible: false,
				goodsImages: [],
				fileList: [],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				loading: false,
				goodsList: [{}], //列表
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],
				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,
				classGoods1List: [],
				classbrandId:'',
				classunitId:'',
				classGoods2List: [],
				classGoods3List: [],
				classGoods1Id: "",
				classGoods2Id: "",
				classGoods3Id: "",
				storeGoodsInfo: {
					classId: "",
					isDh: false,
					status:false,
					
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				storeGoodsId: '', //授权用户id
				storeList: [],
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				unitlist:[],
				page: {
					pageNum: 1,
					pageSize: 10
				},
				pagination: { // 分页参数
				     curPage: 0,
				     pageSize: 5
				   },
				   noMore: false, // 是否有下一页
				pagepp: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
				
				},
				pp:[],
		
				
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
							
						},
					},
					theme: "snow",
				}
			};
		},

		methods: {
			inputsj(e){
				// console.log(e);
				this.$api.pmsbrdselect({name:e}).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.pp = res.data.list
						// this.sliderlist = res.data
					}
				})
			},
			load(){
		
				//   console.log(123456);
			  
			   
			
			},
			
			handleEdit(index, row) {
				// console.log(index, row);
				this.$prompt('请设置协议价', '设置协议价', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
					inputErrorMessage: '请输入数字'
				}).then(({
					value
				}) => {
					this.$message({
					 type: 'success',
						message: '你的邮箱是: ' + value
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			shenhe(id) {
				
				var str = "此操作将审核通过该商品, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.storeGoodsReview(
					this.$encrypt({
						id: id,
						authStatus: 1
					})).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			bohui(id) {
				this.dialogbhVisible = true
				this.ids = id

			},
			sh(id){
				this.$confirm('此操作将审核通过该商品, 是否继续?', '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
				  this.$api.storeGoodsReview(this.$encrypt({
						id: id,
						authStatus: 1
					})).then((res) => {
				  	if (res.state == 'success') {
				  		this.$message({
				  			message: res.message,
				  			type: 'success'
				  		});
				  
				  		this.getStoreGoodsList();
				  	} else {
				  		this.$message.error(res.message);
				  	}
				  
				  })
				}).catch(() => {
				    this.$message({
				        type: 'info',
				        message: '已取消删除'
				    });
				});
				
			},
			suredetail() {

				this.$api.storeGoodsReview(this.$encrypt({
					id: this.ids,
					authStatus: 2,
					detail: this.form.detail
				})).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});

						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}
					this.dialogbhVisible = false
				})
			},
			//导出
			downloadFile() {
				let data = {
					goodsCode: this.searchInfo.goodsCode ? this.searchInfo.goodsCode : "",
					status: this.searchInfo.status ? this.searchInfo.status : "",
					orderType: this.searchInfo.orderType ? this.searchInfo.orderType : "",
					goodsName: this.searchInfo.goodsName ? this.searchInfo.goodsName : "",
					isDh: this.searchInfo.isDh ? this.searchInfo.isDh : "",
					// startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					// cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				};
				//   console.log(data);
				this.$api.commodityExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "商品管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			selectisCrontab(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isCrontab = false

				} else {
					this.storeGoodsInfo.isCrontab = e

				}
				this.$forceUpdate()
			},
			selectisChoiceness(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isChoiceness = false

				} else {
					this.storeGoodsInfo.isChoiceness = e

				}
				this.$forceUpdate()
			},
			handleIsDh(e) {
				if (e == true) {
					this.storeGoodsInfo.isCrontab = false
					this.storeGoodsInfo.isChoiceness = false
				}
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
	
			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			saleset(e){//禁售
				this.$api.forbidSale(e).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			storeGoodsHitTheShelfOrSoldOut(id) {
				this.$api.storeGoodsHitTheShelfOrSoldOut(id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreGoodsList()
			},
			//店铺审核
			editStoreInfoCheck(id, authStatus) {
				if (authStatus == 2) {
					//通过驳回
					var data = {
						id: this.storeGoodsId,
						authStatus: authStatus,
						rejected: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						authStatus: authStatus
					}
				}
				this.$api.storeGoodsReview(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			//审核驳回弹窗打开
			editialogVisible(id) {
				this.form.refuseReason = ""
				this.storeGoodsId = id
				this.editDialogVisible = true;
			},
			// 店铺编辑弹窗
			dialogVisibleFun(id) {
				this.storeInfo = {}
				this.dialogVisibleFunName = "新增商品"
				this.dialogVisible = true;
				this.storeGoodsInfo = {};
				this.classGoods2List = [];
				this.classGoods3List = [];
				this.classGoods1Id = "";
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.goodsImages = [];
				this.storeGoodsInfo.classId = ''
				this.storeGoodsInfo.classIdOne =''
				this.storeGoodsInfo.classIdTwo =''
				this.fileList = [];
			this.classbrandId=""
			this.classunitId=""
				if (id) {
					this.dialogVisibleFunName = "编辑商品"
					this.storeGoodsId = id
					// console.log(id);
					this.$api.storeGoodsFindById(this.storeGoodsId).then((res) => {
						res.data=JSON.parse(this.$decrypt(res.data)).data
						if (res.state == 'success') {
							this.tableData = res.data[0].goodsPriceBs
							this.storeGoodsInfo = res.data[0]
							this.storeGoodsInfo.unitId=res.data[0].unitId
							this.storeGoodsInfo.brandId=res.data[0].brandId
						this.storeGoodsInfo.classId = res.data[0].classId
						this.storeGoodsInfo.classIdOne = res.data[0].classIdOne
						this.storeGoodsInfo.classIdTwo = res.data[0].classIdTwo
							this.classbrandId=res.data[0].brandName
							this.classunitId=res.data[0].unitName
							this.classGoods1Id = res.data[0].c1
							this.classGoods2Id = res.data[0].c2
							this.classGoods3Id = res.data[0].c3
							let imagesArray = res.data[0].images.split(",");
							this.goodsImages = imagesArray;
							for (let i = 0; i < imagesArray.length; i++) {
								this.fileList.push({
									name: imagesArray[i],
									url: imagesArray[i]
								})
							}

						}
					})
				} else {
					this.$api.findIndentity(this.$encrypt({})).then(res => {
						// console.log(res);
						res.data=JSON.parse(this.$decrypt(res.data)).data
						this.tableData = res.data
					})
				}
			},
			//添加商品
			add() {


				this.storeGoodsInfo.images = this.goodsImages.toString();
				// console.log(this.goodsImages.toString(),this.goodsImages)
				// this.storeGoodsInfo.storeId = 1
				// console.log(this.storeGoodsInfo)
				this.storeGoodsInfo.isDh == true ? this.storeGoodsInfo.isDh : false
				this.storeGoodsInfo.isCrontab == true ? this.storeGoodsInfo.isCrontab : false
				this.storeGoodsInfo.isChoiceness == true ? this.storeGoodsInfo.isChoiceness : false
				this.storeGoodsInfo.classId = this.classGoods3Id

				this.storeGoodsInfo.goodsPriceBs = this.tableData
				this.storeGoodsInfo.classIdOne = this.classGoods1Id
				this.storeGoodsInfo.classIdTwo = this.classGoods2Id
				this.$api.addStoreGoods(this.$encrypt(this.storeGoodsInfo)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//编辑商品
			sure() {
				// console.log(this.tableData);
				// this.storeGoodsInfo.images = this.goodsImages.toString();
				// console.log(this.storeGoodsInfo);
				let data = {
					agreementPrice: this.storeGoodsInfo.agreementPrice,
					goodsName: this.storeGoodsInfo.goodsName,
					authStatus: this.storeGoodsInfo.authStatus,
					brandId: this.storeGoodsInfo.brandId,
					unitId: this.storeGoodsInfo.unitId,
					classId: this.storeGoodsInfo.classId,
					classIdOne: this.storeGoodsInfo.classIdOne,
					classIdTwo: this.storeGoodsInfo.classIdTwo,
			
					className: this.storeGoodsInfo.className,
					costPrice: this.storeGoodsInfo.costPrice,
					detail: this.storeGoodsInfo.detail,
					freightPrice: this.storeGoodsInfo.freightPrice,
					goodsCode: this.storeGoodsInfo.goodsCode,
					id: this.storeGoodsInfo.id,
					images: this.goodsImages.toString(),
					isHot: this.storeGoodsInfo.isHot,
					isNegativeStock: this.storeGoodsInfo.isNegativeStock,
					isOpenIdentityPrice: this.storeGoodsInfo.isOpenIdentityPrice,
					marketPrice: this.storeGoodsInfo.marketPrice,
					orderIndex: this.storeGoodsInfo.orderIndex,
					price: this.storeGoodsInfo.price,
					remark: this.storeGoodsInfo.remark,
					salesSum: this.storeGoodsInfo.salesSum,
					status: this.storeGoodsInfo.status,
					stock: this.storeGoodsInfo.stock,
					storeId: this.storeGoodsInfo.storeId,
					storeLogo: this.storeGoodsInfo.storeLogo,
					storeName: this.storeGoodsInfo.storeName,
					userId: this.storeGoodsInfo.userId,
					goodsPriceBs: this.tableData
				}
				// if(this.storeGoodsInfo.isDh===true){
				// 	delete this.storeGoodsInfo.isCrontab
				// 	delete this.storeGoodsInfo.isDiscounts
				// 	delete this.storeGoodsInfo.isChoiceness
				// }
				// this.storeGoodsInfo.classId = this.classGoods3Id
				// this.storeGoodsInfo.classIdOne = this.classGoods1Id
				// this.storeGoodsInfo.classIdTwo = this.classGoods2Id
				// console.log(this.storeGoodsInfo);
				this.$api.editStoreGoods(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}
				})

			},
			//删除
			toDelete(row) {
				/* if (row.status == 0) {
					var str = "此操作将启用该店铺账号, 是否继续?"
				} else {
					var str = "此操作将禁用该店铺账号, 是否继续?"
				} */
				var str = "此操作将删除该商品, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delStoreGoods(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreGoodsList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreGoodsList()
			},
			getStoreGoodsList() {
				this.loading = true
				this.searchInfo.pageNum = this.page.pageNum;
				this.searchInfo.pageSize = this.page.pageSize;
				this.$api.getStoreGoodsList(this.$encrypt(this.searchInfo)).then((res) => { //商品列表
					
						res.data=JSON.parse(this.$decrypt(res.data)).data
						// console.log(res);
					if (res.state == 'success') {
						this.goodsList= res.data
						this.goodsList.list = res.data.list
						// console.log(this.goodsList.list);
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			getStoreAndUser(e) {
				// console.log(e);
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				// this.storeGoodsInfo.supplierId = obj.supplierId;
				this.storeGoodsInfo.supplierName = obj.supplierName;
				this.storeGoodsInfo.address = obj.address;
				this.storeGoodsInfo.phone = obj.phone;
				this.$forceUpdate()
				// console.log(this.storeGoodsInfo.username,this.storeGoodsInfo.storeName,this.storeGoodsInfo.userId)
			},
			getStoreAndUser1(e) {
				// console.log('---', e);
				let obj = {};
				obj = this.storeList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});

				// this.storeGoodsInfo.supplierId = obj.supplierId;
				this.storeGoodsInfo.userId = obj.userId;
				this.$forceUpdate()
				// console.log(this.storeGoodsInfo.username,this.storeGoodsInfo.storeName,this.storeGoodsInfo.userId)
			},
			//选中一级分类
			classGoods1(e) {
				// console.log(e)
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.classGoods3List = {};
				this.classGoods1Id = e
				this.storeGoodsInfo.classIdOne = e;
				if (e) {
					this.$api.goodsClassfindByPid({
						pid: e
					}).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods2List = res.data;
						}
					})
				}
			},
			//选中二级分类
			classGoods2(e) {
				// console.log(e)
				this.classGoods3Id = "";
				this.classGoods2Id = e
				this.classGoods3List = {};
				this.storeGoodsInfo.classIdTwo = e;
				if (e) {
					this.$api.goodsClassfindByPid({
						pid: e
					}).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods3List = res.data;
						}
					})
				}
			},
			//选中三级分类
			classGoods3(e) {
				// console.log(e)
				let obj = {};
				this.classGoods3Id = e
				obj = this.classGoods3List.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.className = obj.className;
				this.storeGoodsInfo.classId = obj.id;
			},
			classbrand(e){
				this.classbrandId=e
				let obj = {};
					obj = this.pp.find((item) => { //这里的userList就是上面遍历的数据源
							return item.id === e; //筛选出匹配数据
						});
						// console.log(obj);
						this.storeGoodsInfo.brandName = obj.brandName;
						this.storeGoodsInfo.brandId = obj.id;
					
			},
			classunit(e){
				this.classunitId=e
				let obj = {};
					obj = this.unitlist.find((item) => { //这里的userList就是上面遍历的数据源
							return item.id === e; //筛选出匹配数据
						});
						// console.log(obj);
						this.storeGoodsInfo.unitName = obj.unitName;
						this.storeGoodsInfo.unitId = obj.id;
					
			},
			//上传店铺logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.storeLogo = res.message
				})
			},
			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.message
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.message
				})
			},

			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			getStoreList() {
				this.$api.getStoreList(this.$encrypt({
					storeType: 1
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storeList = res.data.list;
					}
				})
			},
			getpp(){
			
				let data={
					pageNum:this.pagepp.pageNum,
					pageSize:this.pagepp.pageSize,
				}
				this.$api.pmsbrdselect(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.pp = res.data.list
						// this.sliderlist = res.data
					}
				})
			},
			getunit(){
				this.$api.findPmsUnit().then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.unitlist = res.data.list
						
					}
				})
			}
		},
		created() {
			this.storeId=sessionStorage.getItem('storeId')
			this.getStoreGoodsList();
			this.$api.goodsClassfindByPid({
				pid: 0
			}).then((res) => { //商品一级分类
				if (res.state == 'success') {
					this.classGoods1List = res.data;
				}
			})
			// console.log();
			this.getStoreList()
			this.getpp()
			this.getunit()
		}

	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}

	.redItem {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>
